import { render, staticRenderFns } from "./HomeRegister.vue?vue&type=template&id=d2711552&scoped=true&"
import script from "./HomeRegister.vue?vue&type=script&lang=js&"
export * from "./HomeRegister.vue?vue&type=script&lang=js&"
import style0 from "./HomeRegister.vue?vue&type=style&index=0&id=d2711552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2711552",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
